import axios from "axios";
import API from "@/services/api";

let PRODUCTION_ENV = true;
let sasToken;
let containerName = CONTAINER_NAME;
let storageAccountName = `downloadtsl`;
let isRnelDomain = false;

// Importing all the services
import imagesAndVideos from "./imagesAndVideos";
import sasTokenAPI from "./sasTokenAPI";
import studioAPI from "./studioAPI";
import solark from "./solark";
import solarCalculator from "./solarCalculator";
import editableSiteSurvey from "./editableSiteSurvey";
import wareeAPI from "./waareeAPI";
import heatSolar from "./heatSolar";
import masterDataAPI from "./masterDataAPI";
import { DATABASE_URL, CONTAINER_NAME, GOOGLE_API_KEY } from "../../constants";

export { GOOGLE_API_KEY };

if (location.hostname.includes("rnel")) {
  isRnelDomain = true;
}

export default {
  IMAGES_AND_VIDEOS: imagesAndVideos,
  SAS_TOKEN_API: sasTokenAPI,
  STUDIO_API: studioAPI,
  SOLARK: solark,
  EDITABLE_SITE_SURVEY_API: editableSiteSurvey,
  SOLARCALCULATOR: solarCalculator,
  WAREE: wareeAPI,
  HEAT_SOLAR: heatSolar,
  MASTER_DATA: masterDataAPI,
  SET_DATABASE_URL() {
    axios.defaults.baseURL = DATABASE_URL;
  },
  SET_AXIOS_RESPONSE_HANDLER() {
    axios.interceptors.response.use(
        (response) => {
            //get the type of content returned by the server
            const contentType = response.headers['content-type'];
            //only unpack JSON type responses
            if (
                contentType &&
                contentType.includes('application/json') &&
                typeof response.data === 'object' &&
                response.data !== null
            ) {
                const originalResponse = response.data;
                if (
                    typeof originalResponse === 'object' &&
                    originalResponse !== null &&
                    'success' in originalResponse
                ) {
                    const { data, ...apiDetail } = originalResponse;
                    // Assigning to the response object.
                    response.data = data;
                    response.APIDetail = apiDetail;
                }
            }
            return response;
        },
        (error) => {
            throw error;
        }
    );
},
  async UPDATE_SAS_TOKEN() {
    try{
      const response = await API.SAS_TOKEN_API.FETCH_AND_SET_SAS_TOKEN();
      sasToken = response.data["sas_token"];
    }catch(err){
      console.warn('[API] SAS token endpoint unavailable:', err?.message);
      throw err;
    }
   
  },
};

export { sasToken, containerName, storageAccountName, isRnelDomain };
